<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>Currency Details</h5>
                </div>
                <div class="card-body">
                    <div id="batchDelete" class="custom-datatable">
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col" sortable="title" (sort)="onSort($event)">Currency Title</th>
                                        <th scope="col" sortable="usd" (sort)="onSort($event)">USD</th>
                                        <th scope="col" sortable="code" (sort)="onSort($event)">Code</th>
                                        <th scope="col" sortable="rate" (sort)="onSort($event)">Exchange Rate</th>
                                        <th scope="col"  >Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of tableItem$ | async ">
                                        <td scope="row">
                                           <span>{{item.title}}</span> 
                                        </td>
                                        <td>
                                            {{item.usd}}
                                        </td>
                                        <td>{{item.code}}</td>
                                        <td>{{item.rate}}</td>
                                        <td>
                                            <a href="javascript:void(0)"><i class='fa fa-edit f-12'></i></a>&nbsp;
                                            <a href="javascript:void(0)"><i class="fa fa-trash-o"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Container-fluid Ends-->